import { render } from "./FinalSetupComponent.vue?vue&type=template&id=0c0507e8&scoped=true"
import script from "./FinalSetupComponent.vue?vue&type=script&lang=js"
export * from "./FinalSetupComponent.vue?vue&type=script&lang=js"

import "./FinalSetupComponent.vue?vue&type=style&index=0&id=0c0507e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0507e8"]])

export default __exports__